import React, { useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import Textarea from "../../../form/Textarea";
import { toast } from "react-toastify";
import { mailReply } from "../../../../services/catagoryService";

const validation = {
  message: { required: true, message: "Email body is required" },
};

const ManageReply = ({ close = () => {}, getResponse, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      message:
        "Note: Do not reply to this message—it will not be received. For follow-ups or new inquiries, contact us directly at contact@vpeters.org.",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await mailReply({
        parentId: data?._id,
        email: data?.email,
        message: val?.message,
      });
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        getResponse(res);
        toast.success(res?.message);
        resetField();
        close();
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-6">
          <Input
            label="Email To"
            inputPlaceholder={"Enter Receiver Email"}
            inputName="email"
            value={data?.email || ""}
            isDisabled
          />
        </div>
        <div className="relative col-span-12">
          <Textarea
            label={"Email Body"}
            inputClasses={"!h-40"}
            inputPlaceholder={"Enter Email Body"}
            inputName="message"
            inputValue={values?.message || ""}
            onChange={handleChange}
            {...formValidate(errors, "message")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageReply;
